(() => {
  'use strict';
  const spanishCountries = new Set(['AR','BO','CL','CO','CR','CU','DO','EC','ES','GQ','GT','HN','MX','NI','PA','PE','PR','PY','SV','UY','VE']);
  const prefixes = { en: '', id: '/id', 'zh-CN': '/zh-hans', 'zh-TW': '/zh-hant', es: '/es' };
  const localeForCountry = country => country === 'ID' ? 'id' : country === 'CN' ? 'zh-CN' : ['HK','MO'].includes(country) ? 'zh-TW' : spanishCountries.has(country) ? 'es' : null;
  const localizedURL = (href, locale, roots = prefixes, currentRoot = '') => {
    const url = new URL(href);
    const targetRoot = roots[locale];
    if (typeof targetRoot !== 'string' || (targetRoot !== '' && !/^\/(?!\/)/.test(targetRoot))) return url.href;
    const activeRoot = currentRoot.replace(/\/$/, '');
    let path = url.pathname;
    if (activeRoot && (path === activeRoot || path.startsWith(activeRoot + '/'))) path = path.slice(activeRoot.length) || '/';
    else path = path.replace(/^\/(?:zh-hans-cn|zh-hant-cn|zh-tw-cn|zh-hans|zh-hant|zh-cn|zh-tw|en-cn|id-cn|es-cn|zh|id|es)(?=\/|$)/i, '') || '/';
    url.pathname = targetRoot.replace(/\/$/, '') + (path.startsWith('/') ? path : '/' + path);
    return url.href;
  };
  if (typeof module === 'object' && module.exports) module.exports = { localeForCountry, localizedURL, spanishCountries };
  if (typeof document === 'undefined') return;
  if (window.CellumaRegionRouting) return;
  window.CellumaRegionRouting = { localeForCountry, localizedURL };
  const cookie = name => document.cookie.split('; ').find(value => value.startsWith(name + '='))?.slice(name.length + 1) || '';
  const remember = locale => {
    if (!(locale in prefixes)) return;
    document.cookie = 'celluma_manual_language=' + encodeURIComponent(locale) + '; Path=/; Max-Age=15552000; SameSite=Lax; Secure';
    document.cookie = 'celluma_region_seen=1; Path=/; SameSite=Lax; Secure';
  };
  const initialize = () => {
    document.querySelectorAll('.celluma-localization').forEach(form => {
      if (form.dataset.localizationReady === 'true') return;
      form.dataset.localizationReady = 'true';
      const country = form.querySelector('select[name="country_code"]');
      const summary = form.closest('.region-picker')?.querySelector('summary');
      const label = form.querySelector('label');
      if (summary && label && country) summary.setAttribute('aria-label', label.textContent.trim() + ': ' + country.selectedOptions[0].textContent.trim());
      country?.addEventListener('change', () => {
        const current = form.querySelector('button[name="language_code"][aria-current="true"]')?.value || document.documentElement.lang;
        const desired = localeForCountry(country.value) || current;
        const button = Array.from(form.querySelectorAll('button[name="language_code"]')).find(item => item.value === desired);
        remember(desired);
        if (button) form.requestSubmit(button);
        else {
          let input = form.querySelector('input[name="language_code"]');
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'language_code'; form.append(input); }
          input.value = desired;
          form.requestSubmit();
        }
      });
    });
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.href);
    if (!action.pathname.endsWith('/localization')) return;
    const submitter = event.submitter;
    const locale = submitter?.name === 'language_code' ? submitter.value : new FormData(form).get('language_code');
    if (typeof locale === 'string') remember(locale);
  }, true);
  document.addEventListener('shopify:section:load', initialize);
  const route = async () => {
    initialize();
    const config = document.querySelector('[data-celluma-region-routing]');
    if (!config || config.dataset.preview === 'true' || window.Shopify?.designMode) return;
    if (/bot|crawler|spider|slurp|bingpreview|facebookexternalhit|whatsapp|telegrambot|twitterbot/i.test(navigator.userAgent)) return;
    if (/^\/(?:checkouts?|account|challenge|password|admin)(?:\/|$)/i.test(location.pathname)) return;
    const params = new URLSearchParams(location.search);
    if (params.has('preview_theme_id') || params.has('country') || params.has('locale')) return;
    if (cookie('celluma_manual_language') || cookie('celluma_region_seen')) return;
    document.cookie = 'celluma_region_seen=1; Path=/; SameSite=Lax; Secure';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    try {
      const response = await fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const data = await response.json();
      const country = data.detected_values?.country?.handle?.toUpperCase();
      const locale = localeForCountry(country);
      if (!locale || cookie('celluma_manual_language')) return;
      const available = (config.dataset.availableLanguages || '').toLowerCase().split(',');
      if (!available.includes(locale.toLowerCase())) return;
      const current = config.dataset.locale?.toLowerCase();
      if (current === locale.toLowerCase()) return;
      const roots = JSON.parse(config.dataset.localeRoots || '{}');
      const destination = localizedURL(location.href, locale, roots, config.dataset.currentRoot || '');
      if (destination !== location.href) location.replace(destination);
    } catch (_) {
    } finally {
      clearTimeout(timeout);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', route, { once: true });
  else route();
})();
